import { translateOrderTypeItemName } from "../../../common/enums/orderTypes.enum";
export const canceledOrdersColumns = (t: any) => [
  {
    key: "Number",
    name: t('orders.columns.orderNumber'),
    fieldName: "number",
    minWidth: 50,
    maxWidth: 100,
    isResizable: true,
  },
  {
    key: "CreatedAt",
    name: t('orders.columns.orderDate'),
    fieldName: "createdAt",
    minWidth: 100,
    maxWidth: 120,
    isResizable: true,
  },
  // {
  //   key: "column3",
  //   name: "Data anulowania",
  //   fieldName: "createdAt",
  //   minWidth: 150,
  //   maxWidth: 200,
  //   isResizable: true,
  // },
  {
    key: "Company",
    name: t('orders.columns.client'),
    fieldName: "company",
    minWidth: 400,
    maxWidth: 450,
    isResizable: true,
  },
  {
    key: "ReceptionPlace",
    name: t('orders.columns.receptionPlace'),
    fieldName: "receptionPlace",
    minWidth: 100,
    maxWidth: 350,
    isResizable: true,
  },
  {
    key: "Operator",
    name: t('orders.columns.operator'),
    fieldName: "operator",
    minWidth: 50,
    maxWidth: 100,
    isResizable: true,
  },
  {
    key: "OrderTypeItemName",
    name: t('orders.columns.vehicleType'),
    fieldName: "orderTypeItem",
    minWidth: 50,
    maxWidth: 70,
    isResizable: true,
    onRender: (item: any) => translateOrderTypeItemName(item.orderTypeItem, t),
  },
  {
    key: "Vehicle",
    name: t('orders.columns.vehicle'),
    fieldName: "vehicle",
    minWidth: 50,
    maxWidth: 75,
    isResizable: true,
  },
  {
    key: "ContactPhone",
    name: t('orders.columns.phone'),
    fieldName: "contactPhone",
    minWidth: 50,
    maxWidth: 90,
    isResizable: true,
  },
  {
    key: "IsFromCuo",
    name: t('orders.columns.source'),
    fieldName: "isFromCuo",
    minWidth: 50,
    maxWidth: 80,
    isResizable: true,
  },
  {
    key: "CuoOrderNumber",
    name: t('orders.columns.cuoOrderNumber'),
    fieldName: "cuoOrderNumber",
    minWidth: 80,
    maxWidth: 120,
    isResizable: true,
  },
];